import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "./services/api/apiSlice";
import { setupListeners } from "@reduxjs/toolkit/query/react";
import { createAuthDataSlice } from "./reducer/authSlice";
import { createUserPostSlice } from "./reducer/postSlice";
import {
  createUserInfoSlice,
  createUniversityUserSlice,
  createGlobalSlice,
} from "./reducer/globalSlice";
import { createMarketplaceSlice } from "./reducer/marketplaceSlice";
import { createUserEventSlice } from "./reducer/eventSlice";
import { createCommunitySlice } from "./reducer/communitySlice";
import { syncSlice } from "./modules/syncSlice";
import globalReducer from "./globalCountSlice";
import createPostReducer from "../components/CreateNewPost/redux/postSlice";
import communityCreatePostReducer from "../views/pages/CommunityPage/components/CommunityCreatePost/redux/communityPostSlice";

import { eventStatusReducer } from "./reducer/eventSlice";
import createCommunityModalReducer from "./reducer/createcommunitySlice"
import notificationReducer from "./notificationSlice";
import announcementCountReducer from "./announcementCountSlice";
import communityJoinReducer from "./communityJoinSlice";
import meshNowReducer from "./reducer/meshNowSlice"; 
const authDataSlice = createAuthDataSlice();
const userPostSlice = createUserPostSlice();
const userInfoSlice = createUserInfoSlice();
const universityUserSlice = createUniversityUserSlice();
const sellingDataSlice = createMarketplaceSlice();
const userEventSlice = createUserEventSlice();
const communityDataSlice = createCommunitySlice();



const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
     [syncSlice.reducerPath]: syncSlice.reducer, 
    authData: authDataSlice.reducer,
    userPost: userPostSlice.reducer,
    userInfo: userInfoSlice.reducer,
    universityUser: universityUserSlice.reducer,
    sellingData: sellingDataSlice.reducer,
    userEvent: userEventSlice.reducer,
    communityData: communityDataSlice.reducer,
     global: globalReducer,
    createPost: createPostReducer,
      notifications: notificationReducer,
      announcementCount: announcementCountReducer,
      eventStatus: eventStatusReducer,
      communityJoin: communityJoinReducer,
  createCommunityModal: createCommunityModalReducer,
  communityCreatePost: communityCreatePostReducer,
  meshNow: meshNowReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware)
   .concat(syncSlice.middleware),

   
  devTools: true,
});


setupListeners(store.dispatch);

export default store;
